var map = {
	"./accounting-calculator-2.svg": "5fe7",
	"./accounting-coins-bill.svg": "82b6",
	"./accounting-invoice.svg": "a2a9",
	"./add-square-alternate.svg": "33e0",
	"./add.svg": "f76d",
	"./alert-circle.svg": "55b7",
	"./alert-diamond.svg": "3cb5",
	"./alert-triangle.svg": "8c0d",
	"./angle-brackets.svg": "5db7",
	"./app-window-error-404.svg": "3ddf",
	"./arrow-button-down-2.svg": "f764",
	"./arrow-button-left-1.svg": "53ad",
	"./arrow-button-right-1.svg": "0136",
	"./arrow-button-right-2.svg": "f66b",
	"./arrow-down-1.svg": "d014",
	"./arrow-down.svg": "c244",
	"./arrow-left-1.svg": "83c0",
	"./arrow-left.svg": "9d40",
	"./arrow-right-1.svg": "d59f",
	"./arrow-right.svg": "17ad",
	"./arrow-up-1.svg": "7ae4",
	"./arrow-up.svg": "efbb",
	"./attachment-1.svg": "c61d",
	"./baggage-add.svg": "a89a",
	"./bin.svg": "69c9",
	"./book-flip-page.svg": "69dd",
	"./browser-gauge.svg": "abfb",
	"./building-1.svg": "828d",
	"./button-refresh-arrow.svg": "3c54",
	"./button-refresh-arrows.svg": "0809",
	"./button-split.svg": "28db",
	"./cake-birthday.svg": "34b0",
	"./calendar-3.svg": "4cf1",
	"./calendar-check-1.svg": "63c4",
	"./calendar-clock.svg": "9aeb",
	"./calendar-disable-1.svg": "cf62",
	"./calendar-information.svg": "976d",
	"./calendar-warning.svg": "cb19",
	"./calendar.svg": "05a7",
	"./car.svg": "afa0",
	"./check-1.svg": "314e",
	"./check-circle-1.svg": "0b91",
	"./check-double-1.svg": "ea51",
	"./check-square-alternate.svg": "c6a6",
	"./check.svg": "2598",
	"./checklist-alternate.svg": "42de",
	"./close.svg": "7e32",
	"./cloud-check.svg": "89e5",
	"./cloud-clock.svg": "6b59",
	"./cloud-disable.svg": "798f",
	"./cloud-download.svg": "67dc",
	"./cloud-off.svg": "0fa6",
	"./cloud-remove.svg": "a65e",
	"./cloud-sync.svg": "4588",
	"./cloud-upload.svg": "b83f",
	"./cloud-warning.svg": "6189",
	"./cog-double-3.svg": "1452",
	"./color-brush.svg": "2d33",
	"./color-painting-palette.svg": "894c",
	"./color-palette-sample.svg": "d7de",
	"./common-file-add.svg": "6e15",
	"./common-file-cash.svg": "fb3f",
	"./common-file-check.svg": "f3dc",
	"./common-file-clock.svg": "ef37",
	"./common-file-disable.svg": "a4fb",
	"./common-file-double-1.svg": "d151",
	"./common-file-download.svg": "af8b5",
	"./common-file-empty-alternate.svg": "0daf",
	"./common-file-info.svg": "ed2b",
	"./common-file-lock.svg": "f4ae",
	"./common-file-remove.svg": "50ff",
	"./common-file-stack-alternate.svg": "206e",
	"./common-file-sync.svg": "2fb9",
	"./common-file-text-add.svg": "be61",
	"./common-file-text-alternate.svg": "ddc6",
	"./common-file-text-check.svg": "08e8",
	"./common-file-text-clock.svg": "ae40",
	"./common-file-text-download.svg": "e1f8",
	"./common-file-text-edit.svg": "94e5",
	"./common-file-text-info.svg": "4d14",
	"./common-file-text-lock.svg": "3c9f",
	"./common-file-text-question.svg": "be4e",
	"./common-file-text-remove.svg": "c436",
	"./common-file-text-search.svg": "e7a8",
	"./common-file-text-sync.svg": "ad01",
	"./common-file-text-upload.svg": "4542",
	"./common-file-text-warning.svg": "709f",
	"./common-file-text.svg": "c41a",
	"./common-file-upload.svg": "7fd5",
	"./common-file-warning.svg": "2f54",
	"./copy-paste.svg": "6bd7",
	"./cursor-select.svg": "4de3",
	"./data-file-bars-alternate.svg": "2dca",
	"./data-file-graph-alternate.svg": "5a18",
	"./data-transfer-horizontal.svg": "52ce",
	"./delete-2-alternate.svg": "6b78",
	"./delete.svg": "ff1d",
	"./design-file-pen-alternate.svg": "98b6",
	"./desktop-monitor-settings.svg": "4ecf",
	"./direction-button-arrows.svg": "bd63",
	"./download-bottom.svg": "668a",
	"./email-action-add.svg": "a077",
	"./email-action-edit.svg": "a890",
	"./email-action-remove.svg": "da49",
	"./email-action-send-1.svg": "5ba4",
	"./email-action-settings.svg": "1133",
	"./email-action-sync-1.svg": "6bbe",
	"./eraser-1.svg": "3bee",
	"./expand-full.svg": "2061",
	"./expand-vertical-3.svg": "2072",
	"./file-code-information-1.svg": "8c9e",
	"./filter-2.svg": "07b0",
	"./flag-1.svg": "c276",
	"./folder-file.svg": "9f7d",
	"./folder-search-alternate.svg": "1b58",
	"./folder-search.svg": "b041b",
	"./folder.svg": "ae48",
	"./font-size.svg": "5c92",
	"./graph-stats-ascend.svg": "767c",
	"./graph-stats-descend.svg": "630b",
	"./hard-drive.svg": "2491",
	"./hierarchy-2.svg": "80ef",
	"./hierarchy-5.svg": "0e1a",
	"./hierarchy-6.svg": "9b7f",
	"./human-resources-hierarchy-1.svg": "ace2",
	"./hyperlink-2.svg": "1363",
	"./indent-decrease-1.svg": "29a1",
	"./indent-increase-1.svg": "0dd5",
	"./information-circle.svg": "181e",
	"./itx-arrow-first.svg": "fa43",
	"./itx-arrow-last.svg": "bb5f",
	"./itx-drawer-right-toggle.svg": "34a5",
	"./itx-eco-hub-icon.svg": "0ebb",
	"./itx-file-type-7z.svg": "529a",
	"./itx-file-type-aac.svg": "15f3",
	"./itx-file-type-application.svg": "183e",
	"./itx-file-type-audio.svg": "bf7a",
	"./itx-file-type-avi.svg": "f2ba",
	"./itx-file-type-bmp.svg": "9184",
	"./itx-file-type-csv.svg": "e1c0",
	"./itx-file-type-doc.svg": "3bb9",
	"./itx-file-type-docx.svg": "d9e2a",
	"./itx-file-type-eml.svg": "032e",
	"./itx-file-type-general.svg": "6afd",
	"./itx-file-type-gif.svg": "0db3",
	"./itx-file-type-ics.svg": "5909",
	"./itx-file-type-image.svg": "2f15",
	"./itx-file-type-jpeg.svg": "aa8d",
	"./itx-file-type-jpg.svg": "34f6",
	"./itx-file-type-json.svg": "ca95",
	"./itx-file-type-message.svg": "a54a",
	"./itx-file-type-mka.svg": "87f0",
	"./itx-file-type-mkv.svg": "5cfd",
	"./itx-file-type-mov.svg": "e6c3",
	"./itx-file-type-mp3.svg": "f397",
	"./itx-file-type-mp4.svg": "9567",
	"./itx-file-type-mpeg.svg": "2a54",
	"./itx-file-type-msg.svg": "6479",
	"./itx-file-type-odc.svg": "ebf5",
	"./itx-file-type-odf.svg": "45a2",
	"./itx-file-type-odg.svg": "00d7",
	"./itx-file-type-odi.svg": "6021",
	"./itx-file-type-odm.svg": "1138",
	"./itx-file-type-odp.svg": "efaa",
	"./itx-file-type-ods.svg": "7144",
	"./itx-file-type-odt.svg": "9a3b",
	"./itx-file-type-oga.svg": "4bde",
	"./itx-file-type-ogg.svg": "3dc8",
	"./itx-file-type-ogv.svg": "001b",
	"./itx-file-type-one.svg": "5044",
	"./itx-file-type-oth.svg": "e6c3d",
	"./itx-file-type-pdf.svg": "11cb",
	"./itx-file-type-png.svg": "63c6",
	"./itx-file-type-ppt.svg": "d8d3",
	"./itx-file-type-pptx.svg": "0e06",
	"./itx-file-type-rar.svg": "0ee5",
	"./itx-file-type-rtf.svg": "8814",
	"./itx-file-type-text.svg": "a1f8",
	"./itx-file-type-tif.svg": "558f",
	"./itx-file-type-tiff.svg": "0fcf",
	"./itx-file-type-tsv.svg": "d2d5",
	"./itx-file-type-txt.svg": "ddba",
	"./itx-file-type-unknown.svg": "d28e",
	"./itx-file-type-video.svg": "8589",
	"./itx-file-type-vsd.svg": "f0dc",
	"./itx-file-type-warning.svg": "9b09",
	"./itx-file-type-wav.svg": "88f9",
	"./itx-file-type-weba.svg": "767e",
	"./itx-file-type-webm.svg": "90ce",
	"./itx-file-type-webp.svg": "1e50",
	"./itx-file-type-wma.svg": "4efb",
	"./itx-file-type-wmv.svg": "71a0",
	"./itx-file-type-xls.svg": "c3bf",
	"./itx-file-type-xlsx.svg": "a758",
	"./itx-file-type-xml.svg": "136d",
	"./itx-file-type-zip.svg": "87ad",
	"./itx-hierarchy-6-add.svg": "4e71",
	"./itx-human-resources-hierarchy-add.svg": "2a98",
	"./itx-open-box-character.svg": "5712",
	"./itx-pin-action-edit.svg": "a9a5",
	"./itx-swap.svg": "e19a",
	"./itx-text-bold.svg": "facc",
	"./itx-text-h1.svg": "9d84",
	"./itx-text-h2.svg": "157b",
	"./itx-text-h3.svg": "e4a1",
	"./itx-text-h4.svg": "7e40",
	"./itx-text-h5.svg": "10f2",
	"./itx-text-h6.svg": "d924",
	"./itx-text-italic.svg": "4c44",
	"./itx-text-paragraph.svg": "487e",
	"./itx-text-strike-through.svg": "da16",
	"./itx-text-subscript.svg": "a751",
	"./itx-text-superscript.svg": "5d4d",
	"./itx-text-underline.svg": "ea8f",
	"./keyboard-arrow-bottom-left.svg": "f7af",
	"./keyboard-arrow-bottom-right.svg": "a03a",
	"./keyboard-arrow-down.svg": "99a3",
	"./keyboard-arrow-left.svg": "620c",
	"./keyboard-arrow-next.svg": "8905",
	"./keyboard-arrow-previous.svg": "cdc5",
	"./keyboard-arrow-return-1.svg": "522f",
	"./keyboard-arrow-return.svg": "2b0c",
	"./keyboard-arrow-right.svg": "a0c9",
	"./keyboard-arrow-top-left.svg": "ea9c",
	"./keyboard-arrow-top-right.svg": "53ca9",
	"./keyboard-arrow-up.svg": "c5dc",
	"./list-bullets-1.svg": "1b85",
	"./list-bullets.svg": "ad19",
	"./list-numbers.svg": "a043",
	"./lock-1.svg": "bdec",
	"./lock-unlock.svg": "5d66",
	"./maps-pin-1.svg": "679f",
	"./messages-bubble-square-add.svg": "ab8d",
	"./messages-bubble-square-alternate.svg": "89d9",
	"./messages-bubble-square-text-alternate.svg": "fd1d",
	"./messages-bubble-square.svg": "4ece",
	"./money-wallet-open.svg": "7e49",
	"./monitor.svg": "72a85",
	"./multiple-actions-address.svg": "a969",
	"./multiple-actions-edit-2.svg": "57d0",
	"./multiple-actions-refresh.svg": "b26f",
	"./multiple-actions-remove.svg": "d1a2",
	"./multiple-neutral-2.svg": "9aec",
	"./navigation-left.svg": "5936",
	"./navigation-menu-horizontal.svg": "e097",
	"./navigation-menu.svg": "c65e",
	"./navigation-next-alternate.svg": "35df",
	"./navigation-previous-alternate.svg": "7178",
	"./navigation-right.svg": "f24c",
	"./office-folder-1.svg": "c63f",
	"./open-quote.svg": "1e38",
	"./paragraph-center-align.svg": "ca2f",
	"./paragraph-justified-align.svg": "4b7b",
	"./paragraph-left-align.svg": "8a4f",
	"./paragraph-right-align.svg": "99fa",
	"./paragraph.svg": "390f",
	"./password-lock-2.svg": "1d4a",
	"./pen-write-paper.svg": "c992",
	"./pencil-write-3-alternate.svg": "febc",
	"./pencil.svg": "3ac7",
	"./phone-type.svg": "0643",
	"./pie-line-graph-desktop.svg": "06ed",
	"./pin-add.svg": "121b",
	"./pin.svg": "40d3",
	"./print-text.svg": "944f",
	"./programming-browser-1.svg": "2037",
	"./qr-code-scan.svg": "7abd",
	"./question-circle.svg": "4853",
	"./rating-star.svg": "20e3",
	"./read-email-letter.svg": "afef",
	"./real-estate-action-building-add.svg": "56d8",
	"./redo.svg": "7085",
	"./remove-circle.svg": "4dbc",
	"./resize-expand-sides.svg": "0f2d",
	"./search-alternate.svg": "d5b4",
	"./search-remove.svg": "195e",
	"./send-email-envelope.svg": "10dd",
	"./server-monitor-exchange.svg": "bab8",
	"./server-settings-1.svg": "2fde",
	"./server-sync-1.svg": "9172",
	"./settings-horizontal.svg": "00ea",
	"./settings-user.svg": "88e4",
	"./shield-warning.svg": "764d",
	"./shipment-add.svg": "e83b",
	"./shipment-box.svg": "ff76",
	"./shipment-check.svg": "fd3f",
	"./shipment-disable.svg": "ec53",
	"./shipment-next.svg": "2efa",
	"./shipment-sync.svg": "664f",
	"./shipment-warning.svg": "0142",
	"./sign-badge-circle.svg": "9250",
	"./single-man.svg": "c930",
	"./single-neutral-actions-add.svg": "e49c",
	"./single-neutral-actions-check-1.svg": "cf09",
	"./single-neutral-actions-check.svg": "c11e",
	"./single-neutral-actions-edit-2.svg": "540d",
	"./single-neutral-actions-edit.svg": "b8a4",
	"./single-neutral-actions-information.svg": "17ef",
	"./single-neutral-actions-lock.svg": "a18f",
	"./single-neutral-actions-mail.svg": "c82a",
	"./single-neutral-actions-refresh.svg": "4c50",
	"./single-neutral-actions-remove.svg": "b388",
	"./single-neutral-actions-view.svg": "5200",
	"./single-neutral-phone-book.svg": "fe09",
	"./single-neutral.svg": "88fe",
	"./single-woman.svg": "5bab",
	"./social-profile-bubble.svg": "326b",
	"./style-two-pin-marker.svg": "c8a2",
	"./subtract.svg": "503e",
	"./synchronize-arrow-clock.svg": "944a2",
	"./time-clock-circle-alternate.svg": "352d",
	"./tools-box.svg": "8fe9",
	"./typing.svg": "7a9a",
	"./ui-browser-slider.svg": "6594",
	"./undo.svg": "17e6",
	"./unflag-1.svg": "caf7",
	"./unpin.svg": "6e90",
	"./upload-bottom.svg": "cea4",
	"./view-1.svg": "6649",
	"./view-off.svg": "dcca",
	"./warehouse-package.svg": "b28b",
	"./wifi-check.svg": "d418",
	"./wifi-off.svg": "367e",
	"./wifi-warning.svg": "6cf3",
	"./wifi.svg": "dd92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10cb";